import React from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import './config/Reactotron';
import GlobalStyle from './styles/global';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { store, persistor } from './store';

import history from './services/history';
import Routes from './routes';

function App() {
  return (
    <DndProvider backend={HTML5Backend}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <Router history={history}>
            <Routes />
            <GlobalStyle />
            <ToastContainer autoClose={3000} />
          </Router>
        </PersistGate>
      </Provider>
    </DndProvider>
  );
}

export default App;
